"use client";

type NavTab = "explore" | "all-stories";

const NAV_ITEMS: Array<{
  id: NavTab;
  label: string;
  suffix: string;
  icon: React.ReactNode;
}> = [
  {
    id: "explore",
    label: "explore",
    suffix: "",
    icon: (
      <svg
        fill="none"
        height="20"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="20"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
      </svg>
    ),
  },
  {
    id: "all-stories",
    label: "all stories",
    suffix: "/stories",
    icon: (
      <svg
        fill="none"
        height="20"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="20"
      >
        <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
      </svg>
    ),
  },
];

function _isActiveTab(
  pathname: string,
  exploreBase: string,
  item: (typeof NAV_ITEMS)[number]
) {
  const href = `${exploreBase}${item.suffix}`;
  if (item.id === "explore") {
    if (pathname === href) {
      return true;
    }
    // Match category sub-routes like /en/creative/explore/video-gen
    // but not known sub-pages like /stories
    const afterBase = pathname.slice(href.length);
    if (afterBase.startsWith("/") && !afterBase.startsWith("/stories")) {
      return true;
    }
    return false;
  }
  return pathname === href;
}

// Temporarily hidden — remove `return null` to restore
export function BottomNav() {
  return null;
}
